<script setup lang="ts">
import { computed, watch, nextTick } from 'vue';
import { AIDisclosureStep } from '@/services/ai-disclosure/type/ai-disclosure.enum';
import DisclosureInput from './components/DisclosureInput.vue';
import DisclosureResult from './components/DisclosureResult.vue';
import { useAiDisclosure } from '@/composables/use-ai-disclosure';
import { useHistory } from '@/composables/use-history';
import { useRoute } from 'vue-router';

const { historyData } = useHistory();
const { aiDisclosureService, aiDisclosureData } = useAiDisclosure();
const route = useRoute();
const taskId = computed(() => {
    let taskId = route.params.taskId as string;
    if (taskId === 'new') {
        taskId = '';
    }
    return taskId;
});

async function initDisclosure() {
    const contentId = (route?.query?.id as string) || '';
    await aiDisclosureService.init(taskId.value, contentId);
}

watch(
    taskId,
    () => {
        if (taskId.value && taskId.value === historyData.value.historyDetailTemp.taskId) {
            return;
        }

        nextTick(() => {
            initDisclosure();
        });
    },
    { immediate: true }
);

const showOriginalInput = computed(
    () =>
        aiDisclosureData.value.currentStep === AIDisclosureStep.DISCLOSURE_INPUT
);

const showDisclosureResult = computed(
    () =>
        aiDisclosureData.value.currentStep ===
        AIDisclosureStep.DISCLOSURE_RESULT
);
</script>

<template>
    <div
        id="disclosure"
        class="disclosure h-full w-full overflow-auto"
    >
        <DisclosureInput v-if="showOriginalInput" />
        <DisclosureResult v-if="showDisclosureResult" />
    </div>
</template>
